import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground pt-16 pb-8">
      <div className="container mx-auto px-4">
        
        {/* Links Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          {/* Brand */}
          <div className="space-y-4">
            <h2 className="text-2xl font-serif font-bold">Norsk Frøhandel</h2>
            <p className="text-sm text-primary-foreground/70 leading-relaxed">
              Din nettbutikk for frø, planter og alt til hagen. Vi hjelper deg å lykkes med hagen, balkongen og stua.
            </p>
          </div>

          {/* Kundeservice */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-accent flex items-center gap-2">
               <Clock className="h-5 w-5" /> Kundeservice
            </h4>
            <ul className="space-y-3 text-sm text-primary-foreground/80">
              <li>Vi svarer på e-post innen 1 virkedag</li>
              <li>Mandag – Fredag: 09 – 16</li>
              <li><Link to="/kundeservice" className="hover:text-white transition-colors underline underline-offset-2">Retur og reklamasjon</Link></li>
            </ul>
          </div>

          {/* Informasjon */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-accent">Informasjon</h4>
            <ul className="space-y-3 text-sm text-primary-foreground/80">
              <li><Link to="/om-oss" className="hover:text-white transition-colors">Om oss</Link></li>
              <li><Link to="/kundeservice" className="hover:text-white transition-colors">Retur og reklamasjon</Link></li>
              <li><Link to="/kundeservice" className="hover:text-white transition-colors">Personvern</Link></li>
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-accent">Kontakt Oss</h4>
            <ul className="space-y-4 text-sm text-primary-foreground/80">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-accent shrink-0" />
                <span>Kaj Munks vei 41<br/>0876 Oslo</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-accent shrink-0" />
                <span>+47 932 22 359</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-accent shrink-0" />
                <span>post@norskfrohandel.no</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-primary-foreground/60">
          <p>© {new Date().getFullYear()} Norsk Frøhandel AS. Alle rettigheter reservert.</p>
          <div className="flex gap-6">
            <Link to="/kundeservice" className="hover:text-white">Cookies</Link>
            <Link to="/kundeservice" className="hover:text-white">Driftstatus</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
